/**
 * Safe gtag wrapper.
 *
 * GA4 *events* now flow through the GTM dataLayer (see `datalayer.ts`); this
 * wrapper remains for the Google **Consent Mode** signals (`gtag('consent',
 * 'default'|'update', …)`) that the GTM container and its tags honour.
 *
 * All calls are no-ops on the server or before the gtag stub has loaded.
 * This file also extends the Window interface so TypeScript recognises
 * `window.gtag` and `window.dataLayer`.
 */

declare global {
  // biome-ignore lint/style/useConsistentTypeDefinitions: interface required for global Window augmentation
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

/**
 * Safe wrapper around `window.gtag`.
 * Silently no-ops on the server or if gtag hasn't loaded.
 */
export const gtag = (...args: unknown[]): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (typeof window.gtag === 'function') {
    window.gtag(...args);
  }
};
